//////////////////////////////////////////////////////          //////////////////////////////////////////////////////
//                                                  //          //                                                  //
//  PARA CLIENTES:                                  //          //  PARA FRANQUEADOS:                               //
//                                                  //          //                                                  //
//  APARECE COMO BOTÃO DE                           //          //  APARECE COMO BOTÃO DE                           //
//  POWER-OFF EM TODOS OS HEADERS PORÉM             //          //  POWER-OFF EM TODOS OS HEADERS                   //
//  SÓ QUANDO O USUÁRIO ESTÁ LOGADO                 //          //  SÓ QUANDO O USUÁRIO ESTÁ LOGADO                 //    
//                                                  //          //                                                  //
//  FUNCIONALIDADE: ABRIR O DROPDOWN COM AS OPÇÕES  //          //  FUNCIONALIDADE: CLICKAR PARA REALIZAR           //
//    LOGOUT, TROCAR SENHA E MEUS PEDIDOS           //          //    REALIZAR O LOGOUT DO CATÁLOGO                 //
//                                                  //          //                                                  //
//////////////////////////////////////////////////////          ////////////////////////////////////////////////////// 



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/continuar_comprando.js                  //
//      frontend/src/components/header.js                               //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../../assets/css/local/header.css';

function LogoutButton() {
    async function logout(){  // FUNÇÃO PARA REALIZAR O LOGOUT
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'Logout' (CASO LOGADO COMO FRANQUEADO) DESTE COMPONENTE
        // FUNÇÃO CHAMADA NO CLICK DO OPÇÃO DE 'Logout' NO DORPDOWN DE LOGOUT (CASO LOGADO COMO CLIENTE) DESTE COMPONENTE

        sessionStorage.removeItem('login')  // TIRA O LOGIN DA SESSÃO

        var id_loja = sessionStorage['loja']  // REDIRECIONA PARA A HOME
        window.location.href = '/?id='+ id_loja
    }

    function dropdown(){  //FUNÇÃO PARA ABRIR O DROPDOWN
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Logout' (CASO LOGADO COMO CLIENTE)
        // SÓ UTILIZÁVEL EM CASO DE LOGIN COMO CLIENTE

        if (document.getElementById('dropdown_logout').classList.contains('d-none')){
            document.getElementById('dropdown_logout').classList.remove('d-none')
        }
        else{
            document.getElementById('dropdown_logout').classList.add('d-none')
        }
    }

    function pedidos(){  // FUNÇÃO PARA REDIRECIONAR PARA A PÁGINA DE PEDIDOS
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'Pedidos' NO DROPDOWN DE LOGOUT DESTE COMPONENTE
        // SÓ É UTILIZÁVEL EM CASO DE LOGIN COMO CLIENTE

        window.location.href = '/pedidos_cliente'
    }
    
    function trocar_senha(){  // FUNÇÃO PARA REDIRECIONAR PARA A PÁGINA DE TROCA DE SENHA PARA CLIENTES
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE 'Trocar Senha' NO DROPDOWN DE LOGOUT DESTE COMPONENTE
        // SÓ É UTILIZÁVEL EM CASO DE LOGIN COMO CLIENTE   
        // O BOTÃO PARA REDIRECIONAR FRANQUEADOS PARA A TROCA DE SENHA 
            // FICA NO ARQUIVO 'frontend/src/components/header/carrinho_button.js'   

        window.location.href = '/trocar_senha'
    }    

    if(sessionStorage['login']){  // CASO O USUÁRIO ESTEJA LOGADO
        if(sessionStorage['login'].includes('/')){  // COMO FRANQUEADO
            return (  // NÃO RENDERIZA DROPDOWN
                <div className="col-2" id="logout_btn">
                <div className="d-none d-lg-block header-size">
                    <button className="btn-pretobranco my-1 pull-right px-2 montserrat" onClick={logout}>
                        <i className="fa fa-power-off mr-4"></i>
                        Logout
                    </button>
                </div>
                <div className="d-lg-none header-size">
                    <button className="login-pqn my-1 pull-right" onClick={logout}>
                        <i className="fa fa-power-off"></i>
                    </button>
                </div>
         
            </div>
            );
        }
        else{  // CASO ESTEJA LOGADO COMO CLIENTE
            return (  // RENDERIIZA O DROPDOWN
                <div className="col-2" id="logout_btn">
                <div className="d-none d-lg-block header-size">
                    <button className="btn-pretobranco my-1 pull-right px-2 montserrat" onClick={dropdown}>
                        <i className="fa fa-power-off mr-4"></i>
                        Perfil
                    </button>
                </div>
                <div className="d-lg-none header-size">
                    <button className="login-pqn my-1 pull-right" onClick={dropdown}>
                        <i className="fa fa-power-off"></i>
                    </button>
                </div>
                <div class='dropdown_header montserrat d-none' id='dropdown_logout'>
                                <div class='p-2 item_header' onClick={logout}>
                                    <div class='subitem_header'>Logout</div>
                                </div>
                                <div class='p-2 item_header' onClick={trocar_senha}>
                                    <div class='subitem_header'>Trocar Senha</div>
                                </div>
                                <div class='p-2 item_header' onClick={pedidos}>
                                    <div class='subitem_header'>Meus Pedidos</div>
                                </div>
                            </div>             
            </div>
            );            
        }
    }

    else{  // CASO NÃO ESTEJA LOGADO 
        return (  //  O COMPONENTE NÃO APARECE POR ESTAR COM A CLASSE 'd-none'
        <div className="d-none col-2" id="logout_btn">
            <div className="d-none d-lg-block header-size">
                <button className="btn-pretobranco my-1 pull-right px-2 montserrat">
                    <i className="fa fa-power-off mr-4"></i>
                    Logout
                </button>
            </div>
            <div className="d-lg-none header-size">
                <button className="login-pqn my-1 pull-right">
                    <i className="fa fa-power-off"></i>
                </button>
            </div>        
        </div>        
        );        
    }
        
  }

  export default LogoutButton;
  